import angular from 'angular';
import 'angular-ui-bootstrap'
import 'angular-bootstrap-colorpicker'
import './directives/wysiwyg.es6';

var commonApp = angular.module("common_app", ['wysiwyg.module', 'colorpicker.module']);

export default commonApp;